import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/img/home-rule.png'
import _imports_1 from '@/assets/img/mylist-btn.png'
import _imports_2 from '@/assets/img/home-btn1.png'
import _imports_3 from '@/assets/img/home-btn2.png'
import _imports_4 from '@/assets/img/xf.png'


const _hoisted_1 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_2 = { class: "home-box" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_4 = { class: "btns" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "home-xiaofeng" }, [
  /*#__PURE__*/_createVNode("img", { src: _imports_4 })
], -1)
const _hoisted_6 = { class: "notice grandiant-color" }
const _hoisted_7 = { class: "flex-wrap" }
const _hoisted_8 = /*#__PURE__*/_createVNode("span", null, "恭喜", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Rule = _resolveComponent("Rule")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", {
      class: ["home-wrapper", _ctx.showRule && 'blur']
    }, [
      _createVNode("div", {
        class: "rule btn",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showRule = true))
      }, [
        _hoisted_1
      ]),
      _createVNode("div", _hoisted_2, [
        _createVNode("div", {
          class: "my-list btn",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goPage(_ctx.goRecord)))
        }, [
          _hoisted_3
        ]),
        _createVNode("div", _hoisted_4, [
          _createVNode("img", {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goPage(_ctx.goSelect))),
            class: "btn",
            src: _imports_2
          }),
          _createVNode("img", {
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.goPage(_ctx.goMarket))),
            class: "btn",
            src: _imports_3
          })
        ]),
        _hoisted_5
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode("div", {
          style: { animationDuration: (_ctx.notices.length * 3) + 4 + 's', }
        }, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.notices, (item, index) => {
            return (_openBlock(), _createBlock("div", {
              class: "notice-item",
              key: index
            }, [
              _createVNode("div", _hoisted_7, [
                _hoisted_8,
                _createVNode("img", {
                  src: item.avatar || require('@/assets/img/avatar.png')
                }, null, 8, ["src"]),
                _createVNode("span", null, _toDisplayString(item.name  + (item.amount ? '获得' + item.amount + '元' + item.prizeName :  '在封面集市兑换了' + item.prizeName)), 1)
              ])
            ]))
          }), 128))
        ], 4)
      ])
    ], 2),
    (_ctx.showRule)
      ? (_openBlock(), _createBlock(_component_Rule, {
          key: 0,
          onClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showRule = false))
        }))
      : _createCommentVNode("", true)
  ], 64))
}